module.exports = __webpack_public_path__ + "img/aboutUs_img10.db903e29.svg";